// APES
export const WANDERLIST_FAVORITES = "apes_apes2174-wanderlist-favorites";

// CHURNBUSTERS
export const TRIPLIST_REDIRECTION = "PRIME_CB1511";

// SUMO
export const HOME_TOUCHPOINTS_REDIRECTIONS = "FSC_SUMO4948";

// ACME
export const HSA_SIGNOUT_RELOAD = "acme_acme2208-signout-reload-v1";

// DPT
export const HSA_RESULTS_MOBILE_LAYOUT_V2 = "dpt_dpt6823";

// KEEPERS
export const USER_VERIFICATION_MODAL = "PRIME_KEEP2886";
export const CUSTOM_LOGIN = "PRIME_KEEP1413";
export const RESULTS_CUSTOM_LOGIN = "PRIME_KEEP2984";
export const LOGIN_MENU_WITH_NO_PAGE_RELOAD = "keep-3010-login-with-no-reload";
export const PAX_SIGNIN_TOUCHPOINT = "PRIME_KEEP3037";

export const FEATURE_ALIASES = {
  HOME_TOUCHPOINTS_REDIRECTIONS,
  WANDERLIST_FAVORITES,
  HSA_RESULTS_MOBILE_LAYOUT_V2,
  USER_VERIFICATION_MODAL,
  CUSTOM_LOGIN,
  RESULTS_CUSTOM_LOGIN,
  TRIPLIST_REDIRECTION,
  LOGIN_MENU_WITH_NO_PAGE_RELOAD,
  PAX_SIGNIN_TOUCHPOINT,
};
